import { Directive } from '@angular/core';
import {
  HierarchyListViewProviderDirective,
  TreeNodeWithOriginalData
} from '@app/providers';
import {
  ListView,
  ListViewProviderDirective,
  NtapGlobalConstants,
  Util
} from '@ntap/core';

@Directive({
  selector: '[appKlasaHierarchyListViewProvider]',
  exportAs: 'appKlasaHierarchyListViewProvider',
  providers: [
    {
      provide: HierarchyListViewProviderDirective,
      useExisting: KlasaHierarchyListViewProviderDirective
    },
    {
      provide: ListViewProviderDirective,
      useExisting: KlasaHierarchyListViewProviderDirective
    }
  ]
})
export class KlasaHierarchyListViewProviderDirective extends HierarchyListViewProviderDirective {
  protected override mapNewState(
    view: ListView,
    parentNode: TreeNodeWithOriginalData
  ) {
    const parentNodeData = parentNode.data;
    const itemType =
      parentNodeData[NtapGlobalConstants.ATTR_$itemType] ||
      parentNodeData[NtapGlobalConstants.ATTR_$mainType];
    const hierarchyAttr = (this as any).getHierarchyAttribute(view);
    const newState = {
      [hierarchyAttr['$fqan']]:
        parentNodeData[
          Util.getFullAttrName(itemType, NtapGlobalConstants.ATTR_id)
        ],
      [NtapGlobalConstants.ATTR_$parent]: parentNodeData
    };
    return {
      ...this.viewState,
      ...newState
    };
  }
}
